import {
  APP_SETTING_LOAD_ALL_RESOURCES_BEGIN,
  APP_SETTING_LOAD_ALL_RESOURCES_SUCCESS,
  APP_SETTING_LOAD_ALL_RESOURCES_FAILURE,
  APP_SETTING_LOAD_ALL_RESOURCES_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadAllResources(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_ALL_RESOURCES_BEGIN,
    });

    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}resource/get-resources`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_ALL_RESOURCES_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_ALL_RESOURCES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAllResourcesError() {
  return {
    type: APP_SETTING_LOAD_ALL_RESOURCES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_ALL_RESOURCES_BEGIN:
      return {
        ...state,
        loadAllResourcesPending: true,
        loadAllResourcesError: null,
      };

    case APP_SETTING_LOAD_ALL_RESOURCES_SUCCESS:
      return {
        ...state,
        loadAllResourcesPending: false,
        loadAllResourcesError: null,
        allResources: action.data,
      };

    case APP_SETTING_LOAD_ALL_RESOURCES_FAILURE:
      return {
        ...state,
        loadAllResourcesPending: false,
        loadAllResourcesError: action.data.error,
      };

    case APP_SETTING_LOAD_ALL_RESOURCES_DISMISS_ERROR:
      return {
        ...state,
        loadAllResourcesError: null,
      };

    default:
      return state;
  }
}
